import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import CountUp from 'react-countup';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import LocationSelect from '../../../Components/LocationSelect';
import ThematicAreaDisplay from '../../../Components/ThematicAreaDisplay/ThematicAreaDisplay';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { Button, Form } from 'react-bootstrap';
import { isEmpty } from '../../../_helpers/_methods';

function Dashboard() {
  const fiscalYear = useSelector((state) => state.fiscalyear?.activeFiscalYear);
  const lang = useSelector((state) => state.local.local);
  const [dashboardData, setDashBoardData] = useState({});
  const [selectedFederal, setSelectedFederal] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedLocalLevel, setSelectedLocalLevel] = useState(null);
  const [thematicAreas, setThematicAreas] = useState({});
  const [loadingDashboardData, setLoadingDashboardData] = useState(false);
  const [dashStats, setDashStats] = useState({
    thematic_area: 0,
    total_events: 0,
    resource_persons: 0,
    participants: 0
  });
  const [options, setOptions] = useState({});

  useEffect(() => {
    let xAxisCategories = [];
    if (lang === 'ne') {
      xAxisCategories = [
        'श्रावण',
        'भाद्र',
        'असोज',
        'कात्तिक',
        'मंसिर',
        'पुस',
        'माघ',
        'फागुन',
        'चैत',
        'बैशाख',
        'जेठ',
        'असार'
      ];
    } else {
      xAxisCategories = [
        'Shrawan',
        'Bhadra',
        'Ashwin ',
        'Kartik	',
        'Mangsir',
        'Poush',
        'Magh',
        'Falgun',
        'Chaitra',
        'Baishakh',
        'Jestha',
        'Ashad'
      ];
    }
    setOptions({
      title: {
        text:
          lang === 'ne' ? `आर्थिक वर्ष: ${fiscalYear?.title}` : `Fiscal year: ${fiscalYear?.title}`
      },
      chart: {
        stacked: true,
        id: 'basic-bar'
      },
      xaxis: {
        categories: xAxisCategories
      },
      yaxis: {
        minWidth: 1
      }
    });
  }, [lang, fiscalYear]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoadingDashboardData(true);
        const response = await fetchWrapper.get('/admin/dashboard/');
        const data = response.data;
        setDashBoardData(data);
        let series = [];

        Object.entries(data.provinces).forEach(([key, value]) => {
          series.push({
            name: key,
            data: value.data
          });
        });
        setSeries(series);

        setThematicAreas({
          thematicAreas: data.overall.thematic_areas,
          total: data.overall.thematic_area
        });
        setDashStats({
          thematic_area: data.overall.thematic_area,
          total_events: data.overall.total_events,
          resource_persons: data.overall.resource_persons,
          participants: data.overall.participants
        });
        setLoadingDashboardData(false);
      } catch (err) {
        setLoadingDashboardData(false);
        console.log(err);
      }
    };
    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (isEmpty(dashboardData)) return;
    let selectedProvinceData, series;
    if (selectedFederal) {
      selectedProvinceData = dashboardData.provinces['संघिय कार्यक्रम'];
      series = [
        {
          name: 'संघिय तह',
          data: selectedProvinceData?.data
        }
      ];
      setSelectedProvince(false);
    } else if (selectedProvince) {
      selectedProvinceData = dashboardData.provinces[selectedProvince.value];
      series = [
        {
          name: selectedProvince.value,
          data: selectedProvinceData?.data
        }
      ];
    } else {
      series = [];
      selectedProvinceData = dashboardData.overall;
      Object.entries(dashboardData.provinces).forEach(([key, value]) => {
        series.push({
          name: key,
          data: value.data
          // color: '#ff0e5a'
        });
      });
    }
    setSeries(series);
    setDashStats({
      total_events: selectedProvinceData?.total_events,
      thematic_area: selectedProvinceData?.thematic_area,
      resource_persons: selectedProvinceData?.resource_persons,
      participants: selectedProvinceData?.participants
    });
    setThematicAreas({
      thematicAreas: selectedProvinceData?.thematic_areas,
      total: selectedProvinceData?.thematic_area
    });
  }, [selectedProvince, selectedFederal]);

  const handleFederalCheck = (e) => {
    setSelectedFederal(e.target.checked);
  };

  const clearStats = () => {
    setSelectedFederal(false);
    setSelectedProvince(false);
  };
  return (
    <div className="card content-section">
      <div className="row card-header d-flex justify-content-between mx-0">
        <div className="col-6 d-flex ">
          <h3 className=" text-primary d-inline-block">
            <FormattedMessage id="dashboard" />
          </h3>
        </div>
        <div className="col-6 row d-flex">
          <div className="col-4 d-flex align-items-center justify-content-end">
            <Form.Check
              checked={selectedFederal}
              type={'checkbox'}
              id="sd"
              label={lang === 'ne' ? 'संघीय कार्यक्रम' : 'Federal Events'}
              onChange={handleFederalCheck}
            />
          </div>
          <div className="col-4">
            <LocationSelect
              id="location"
              selectedProvince={selectedProvince}
              setSelectedProvince={setSelectedProvince}
              selectedDistrict={selectedDistrict}
              setSelectedDistrict={setSelectedDistrict}
              selectedLocalLevel={selectedLocalLevel}
              setSelectedLocalLevel={setSelectedLocalLevel}
              isDashboard={true}
              isDisabled={selectedFederal}
            />
          </div>

          <div className="col-4 d-flex justify-content-end">
            <Button variant="outline-primary" onClick={clearStats}>
              <FormattedMessage id="overall_stat" />
            </Button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="row g-6 mb-6">
          <div className="col-xl-3 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <span className="h6 font-semibold text-muted text-sm d-block mb-2">
                      <FormattedMessage id="dashboard.total_events" />
                    </span>{' '}
                    <span className="h3 font-bold mb-0">
                      <CountUp start={0} end={dashStats.total_events} />
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-tertiary text-white text-lg rounded-circle">
                      <i className="bi bi-credit-card" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <span className="h6 font-semibold text-muted text-sm d-block mb-2">
                      <FormattedMessage id="dashboard.enrolled_participants" />
                    </span>{' '}
                    <span className="h3 font-bold mb-0">
                      <CountUp start={0} end={dashStats.participants} />
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-primary text-white text-lg rounded-circle">
                      <i className="bi bi-people" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <span className="h6 font-semibold text-muted text-sm d-block mb-2">
                      <FormattedMessage id="dashboard.enrolled_resource_person" />
                    </span>{' '}
                    <span className="h3 font-bold mb-0">
                      <CountUp start={0} end={dashStats.resource_persons} />
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-info text-white text-lg rounded-circle">
                      <i className="bi bi-clock-history" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <span className="h6 font-semibold text-muted text-sm d-block mb-2">
                      <FormattedMessage id="thematicAreas" />
                    </span>{' '}
                    <span className="h3 font-bold mb-0">
                      <CountUp start={0} end={dashStats.thematic_area} />
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-warning text-white text-lg rounded-circle">
                      <i className="bi bi-minecart-loaded" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row my-4">
          <div className="col-8">
            <div className="card">
              <div className="card-body">
                {loadingDashboardData ? (
                  <div> loading ... </div>
                ) : (
                  <Chart options={options} series={series} type="bar" key={options} />
                )}
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="card">
              <div className="card-header">
                <h5 className="sub-heading">
                  <FormattedMessage id={'event.includedthematicArea'} />
                </h5>
              </div>
              <div className="card-body">
                <ThematicAreaDisplay thematicAreas={thematicAreas} loading={loadingDashboardData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
